import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { SiteDataProvider } from "./context/SiteData";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import History from "./pages/History";
import Services from "./pages/Services";
import Locations from "./pages/Locations";
import LocationDetail from "./pages/LocationDetail";
import Gallery from "./pages/Gallery";
import Newspaper from "./pages/Newspaper";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import LegacyLocationRedirect from "./pages/LegacyLocationRedirect";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <SiteDataProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/history" element={<History />} />
              <Route path="/services" element={<Services />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/locations/:id" element={<LocationDetail />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/newspaper" element={<Newspaper />} />
              <Route path="/career" element={<Career />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/location/:encoded" element={<LegacyLocationRedirect />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          <Toaster />
        </BrowserRouter>
      </SiteDataProvider>
    </div>
  );
}

export default App;
